<template>
  <div class="row">
    <div class="col-12">
      <div class="p-3 border-bottom">
        <CheckBox
          v-model="active_sync"
          class="font-weight-light"
          :text="activatorText"
          :disabled="disabled"
        />
      </div>
    </div>
    <div v-if="active" class="col-12">
      <slot />
    </div>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';

export default {
  name: 'CollapsableItem',
  components: { CheckBox },
  props: {
    active: { type: Boolean, default: false },
    activatorText: { type: String, default: 'Mostrar' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    active_sync: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit('update:active', value);
      },
    },
  },
};
</script>
